export default __webpack_public_path__ + "static/media/emotionsBreakdown.3503dfa7.png";